import type { Listing } from '@thevillages/schemas';

import { Component, computed, inject, input } from '@angular/core';

import { FilteringService } from '../../../services/filtering';
import { ModelCard } from '../../model-card/model-card';
import { ListingDetailsAccordion } from '../accordion/accordion';

@Component({
  imports: [ModelCard, ListingDetailsAccordion],
  selector: 'app-listing-details-will-accommodate',
  templateUrl: './will-accommodate.html',
})
export class ListingDetailsWillAccommodate {
  private readonly _filteringService = inject(FilteringService);

  public readonly listing = input.required<Listing>();

  protected readonly accomodatedModels = computed(() => {
    if (!this.listing().willAccommodate?.models) {
      return [];
    }
    if (!this._filteringService.availableModels.hasValue()) {
      return [];
    }

    const _models = [];

    for (const _model of this.listing().willAccommodate?.models ?? []) {
      const _modelDetails = this._filteringService.availableModels
        .value()
        .find((m) => m.id === _model);

      if (_modelDetails?.images && _modelDetails.images.length > 0) {
        _models.push(_modelDetails);
      }
    }

    return _models;
  });
}
